<template>
  <div class="representatives EOPPBlock">
    <div class="representativeHeader">
      <span class="representativeTitle">REPRESENTANTES</span>
      <slot />
    </div>

    <tip :info="info" />

    <div class="leaders">
      <div class="leader">
        <span class="leaderName">{{ organization.leader1.name }}</span>
        <span class="leaderSurname">{{ organization.leader1.surname }}</span>
        <span class="leaderPosition">{{ organization.leader1.position }}</span>
        <img
          :src="
            organization.leader1.picture
              ? organization.leader1.picture
              : organization.leader1.googlePictureURL
          "
          v-if="
            organization.leader1.picture ||
              organization.leader1.googlePictureURL
          "
        />
        <img src="../../../assets/img/avatar.png" v-else />
        <span class="leaderCouse">{{ organization.leader1.course }}</span>
        <br />
        <span class="leaderEmail">{{ organization.leader1.email }}</span>
        <br />
        <span class="leaderCell">{{ organization.leader1.cellphone }}</span>
      </div>

      <div class="leader">
        <span class="leaderName">{{ organization.leader2.name }}</span>
        <span class="leaderSurname">{{ organization.leader2.surname }}</span>
        <span class="leaderPosition">{{ organization.leader2.position }}</span>
        <img
          :src="
            organization.leader2.picture
              ? organization.leader2.picture
              : organization.leader2.googlePictureURL
          "
          v-if="
            organization.leader2.picture ||
              organization.leader2.googlePictureURL
          "
        />
        <img src="../../../assets/img/avatar.png" v-else />
        <span class="leaderCouse">{{ organization.leader2.course }}</span>
        <br />
        <span class="leaderEmail">{{ organization.leader2.email }}</span>
        <br />
        <span class="leaderCell">{{ organization.leader2.cellphone }}</span>
      </div>

      <div v-for="(contact, i) in members" :key="i" class="contact">
        <span class="contactName"> {{ i + 1 }}. {{ contact.name }} </span>
        <br />
        <span class="contactEmail"> {{ contact.email }} </span>
      </div>
    </div>

    <div class="seeMore" v-if="organization.otherContacts.length > 2">
      <div class="button" @click="showAllmembers = !showAllmembers">
        <span v-if="showAllmembers">Ver menos</span>

        <span v-else>Ver mais</span>

        <b-icon :icon="showAllmembers ? 'caret-up' : 'caret-down'"></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tip from "../commom/Tip2.vue";

export default {
  components: {
    tip
  },

  data() {
    return {
      showAllmembers: false,
      info: {
        infoBorder: false,
        buttonText: "IMPORTANTE",
        descriptionText:
          "Os 2 representantes poderão solicitar Ações de Desenvolvimento em nome da OE e poderão ser trocados a qualquer momento."
      }
    };
  },

  computed: {
    ...mapGetters(["organization"]),

    members() {
      return this.showAllmembers
        ? this.organization.otherContacts
        : [
            this.organization.otherContacts[0],
            this.organization.otherContacts[1]
          ];
    }
  }
};
</script>

<style scoped>
.representatives {
  margin-top: 0.5rem;
}
.representativeHeader {
  background: rgb(2, 209, 168);
  background: linear-gradient(
    90deg,
    rgba(2, 209, 168, 1) 0%,
    rgba(95, 255, 223, 1) 100%,
    rgba(60, 247, 210, 1) 100%
  );
  border: transparent;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
}
.representativeTitle {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 2rem;
  margin-top: 0.5rem;
}
.representativeTip {
  display: flex;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.leaders {
  display: grid;
  grid-template-columns: auto auto;
  gap: 0.5rem;
  margin: 0.5rem;
}
.leader {
  background-color: black;
  display: block;
  padding: 2rem;
  border-radius: 0.5rem;
}
.leaderName {
  color: #02f8c7;
  font-size: 2.2rem;
  font-weight: 600;
  display: flex;
  width: fit-content;
}
.leaderSurname {
  color: white;
  font-size: 2.2rem;
  font-weight: 600;
  display: flex;
  width: fit-content;
}
.leaderPosition {
  color: white;
  display: flex;
  font-size: 1.3rem;
  margin-top: 1rem;
}
.leader img {
  background-color: white;
  border: solid #02f8c7;
  border-radius: 100%;
  width: 12rem;
  min-width: 12rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4rem;
  margin-bottom: 4rem;
  box-shadow: 0px 0px 50px 10px rgba(2, 248, 199, 0.86);
}

.leaderCouse,
.leaderEmail,
.leaderCell {
  color: white;
  font-size: 1.3rem;
}

.contact {
  border: solid 0.5px rgb(233, 233, 233);
  border-radius: 0.5rem;
  display: block;
  padding: 2rem;
  font-size: 1.5rem;
}

.contactName {
  font-weight: 600;
  color: rgb(82, 82, 82);
}

.contactEmail {
  color: rgb(82, 82, 82);
}

.seeMore {
  height: 3rem;
}

.seeMore .button {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  border: transparent;
  color: gray;
}

.seeMore .button .icon {
  color: gray;
}

@media (max-width: 730px) {
  .leaders {
    grid-template-columns: auto;
  }
}
@media (max-width: 400px) {
  .leaderName,
  .leaderSurname {
    font-size: 1.5rem;
  }
  .leaderPosition {
    font-size: 1rem;
  }
  .leaderCouse,
  .leaderEmail,
  .leaderCell {
    font-size: 1rem;
  }
  .leader img {
    width: 9rem;
    min-width: 9rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .contact {
    font-size: 1.2rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    border: none;
  }
}
</style>
